import React from 'react'

import './Footer.css'
const Footer = () => {
  return (
    <>
    
    <div className="footer-container">
        
        <a href='https://abhiimali.github.io'  
           className='footer-link' 
           target='_blank' 
           rel='noreferrer' >

                     Designed And Developed By Abhii Mali 
         </a>
        

    </div>

    
    </>
  )
}

export default Footer ;